interface DetailRowProps {
    label: string;
    children: React.ReactNode;
}

export function DetailRow({ label, children }: DetailRowProps) {
    return (
        <div className="border border-grey-600 rounded-[10px] p-4 flex items-center justify-between gap-4">
            <span className="text-sm text-grey-200">{label}</span>
            <div className="text-sm text-white-100 text-right">{children}</div>
        </div>
    );
}
